import { ApiError } from "../api";
import { msg } from "../messages";

export function setSheetError(form: HTMLFormElement, message: string | null): void {
    const existing = form.querySelector(".item-sheet-error");
    if (!message) {
        existing?.remove();
        return;
    }

    const el = existing ?? document.createElement("p");
    if (!existing) {
        el.className = "item-sheet-error";
        el.setAttribute("role", "alert");
        form.querySelector(".item-sheet-submit")?.insertAdjacentElement("beforebegin", el);
    }
    el.textContent = message;
}

export function uploadErrorMessage(err: unknown): string {
    if (err instanceof ApiError) return err.message;
    if (err instanceof TypeError) return msg("app/server-unreachable");
    if (err instanceof Error && err.message) return err.message;
    return msg("toast/image-upload-failed");
}
